import { useAtomValue } from 'jotai';
import type { ImageSource } from 'maplibre-gl';
import { useEffect } from 'react';
import { useMap } from '@/features/map';
import { unitsAtom } from '@/features/units';
import { marginColorStops } from '../model/colorScale';
import { resultAtom } from '../state/atoms';
import { coneImage } from './coneImage';
import { BLANK_CONE_IMAGE, CONE_SOURCE } from './glideStyle';

/** Draws the result raster; colours depend on the unit system's legend steps. */
export function ConeLayer() {
  const map = useMap();
  const result = useAtomValue(resultAtom);
  const units = useAtomValue(unitsAtom);

  useEffect(() => {
    const image = result ? coneImage(result, marginColorStops(units)) : BLANK_CONE_IMAGE;
    map?.getSource<ImageSource>(CONE_SOURCE)?.updateImage(image);
  }, [map, result, units]);

  return null;
}
